import validate from '@/api/validate'

export default {
  referenceNumber ({ commit }, payload) {
    return validate.referenceNumber(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          return response.data.status
        }
      })
  }
}
